/*
 * Authors: mariushirjanu
 * Created: 16/02/2022
 */
import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ClipboardService, IClipboardResponse } from 'ngx-clipboard';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { GaMessageService } from '../message/ga-message.service';

@Component({
  selector: 'copy-to-clipboard',
  template: `
    <button #popover="bs-popover" class="btn btn-default btn-xs" type="button" containerClass="popover-clipboard" (click)="copyToClipboard()" title="Copy to clipboard" popover="Copied" placement="bottom" triggers>
      <i class="fa fa-clipboard"></i> Copy
    </button>
  `,
  styleUrls: [ './copy-to-clipboard.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class CopyToClipboardComponent {
  @ViewChild('popover') popover:PopoverDirective;
  // value or dom element
  @Input() public value?:string;          // value to be copied to clipboard
  @Input() public element?:string;        // eg: .report-sql-query, the formatted content of the element to be copied to clipboard
  @Input() public statusMessage?:boolean; // when true: display a status message instead of button feedback (ng2 popover stucks to display a button feedback when used in a ng1 screen)

  constructor(
    private clipboardService:ClipboardService,
    private messageService:GaMessageService
  ) {
    this.handleClipboardResponse();
  }

  public copyToClipboard():void {
    if(this.element){
      this.copyElementToClipboard(this.element);
    } else {
      this.clipboardService.copy(this.value);
    }

    // display popover message
    if(!this.statusMessage) {
      this.popover.show();
      setTimeout(() => {
        this.popover.hide();
      }, 1000);
    } else {
      this.messageService.showFeedbackMessage('Copied to clipboard');
    }
  }

  private handleClipboardResponse():void {
    this.clipboardService.copyResponse$
      .subscribe((res:IClipboardResponse) => {
        if(!res?.isSuccess){
          // if not succeded -> hide immediately the popup message and display an error in console
          setTimeout(() => {
            this.popover.hide();
            console.error(`Content cannot be copied to clipboard: ${res.content}`);
          });
        }
      });
  }

  // this copies to clipboard the inner value of the DOM element but also including new lines (e.g. SQL query in reports)
  private copyElementToClipboard(element:string): void {
    const brRegex:RegExp = /<br\s*[\/]?>/gi;
    const html:string = $(element).html()
      .replace(brRegex, '\r\n') // format new line
      .replace(/&amp;/g, '&')   // replace html entity to &
      .replace(/&lt;/g, '<')    // replace html entity to <
      .replace(/&gt;/g, '>');   // replace html entity to >
    const tempTextarea:JQuery = $('<textarea>');
    $('body').append(tempTextarea);
    tempTextarea.val(html).select();
    document.execCommand('copy');
    tempTextarea.remove();
  }
}